export default {
    /// <summary>
    /// 操作成功
    /// </summary>
    SUCCESS_CODE: 0,

    /// <summary>
    /// 拒绝访问
    /// </summary>
    ACCESS_DENIED_CODE: -10242403,

    /// <summary>
    /// 一般错误业务异常
    /// </summary>
    COMMON_BIZ_ERROR_CODE: -10250000,

    /// <summary>
    /// 必要参数为空
    /// </summary>
    REQUIRE_PARAM_EMPTY_CODE: -10250001,

    /// <summary>
    /// 参数格式错误
    /// </summary>
    PARAM_FORMAT_WRONG_CODE: -10250002,

    /// <summary>
    /// 该接口需要登录，或者登录已超时
    /// </summary>
    REQUIRED_AUTH_CODE: -10250003,

    /// <summary>
    /// 业务校验失败
    /// </summary>
    BIZ_VALIDATE_FAIL_CODE: -10250004,

    /// <summary>
    /// 数据已经被删除
    /// </summary>
    DATA_NOT_FOUND_CODE: -10250404,

    /// <summary>
    /// 拒绝操作，该操作不被允许
    /// </summary>
    OPERATION_FORBIDDEN_CODE: -10250403,

    /// <summary>
    /// 内部错误
    /// </summary>
    INTERNAL_ERROR_CODE: -10250500,

    /// <summary>
    /// 操作成功 但是被限制  比如包含敏感词
    /// </summary>
    SUCCESS_BUT_CODE: -10250600,

    /// <summary>
    /// 操作次数太多或者太频繁
    /// </summary>
    TOO_MANY_ACTION: -10250601,

    /// <summary>
    /// 远程调用业务业务结果失败
    /// </summary>
    REMOTE_FAIL_CODE: -10250602,

    /// <summary>
    /// 远程调用异常
    /// </summary>
    REMOTE_ERROR_CODE: -10250603,
};



// WEBPACK FOOTER //
// ./src/utils/error_codes.js